import {InitPage} from "../../index";

declare var nonScheduledProductionPath: string;
declare var zoneId: string;
export class ElcProductionNew {
    constructor(){}

    initializeHTML() {
        const _this = this;
        if(nonScheduledProductionPath == undefined) {
            console.log("loading nonScheduledProductionPath in an un required page")
        } else {
            $(".production-items-list").select2({
                placeholder: "",
                allowClear: true,
                ajax: {
                    url: nonScheduledProductionPath
                },
                dropdownParent: $("#elc-production-form"),
                templateSelection: _this.updateProductionMetadata
            });
        }
    }

    updateProductionMetadata(e: any) {
        if(e.id != "") {
            $("#production_wo").text(e.wo);
            $("#production_so").text(e.so);
            $("#production_po").text(e.po);
            $("#production_alu").text(e.name);
            $("#production_item_number").text(e.alu);
            $("#production_item_type").text(e.item_type);
            $("#production_customer_name").text(e.customer_name);
            $("#elc_production_id").val(e.id);
            $("#production_start_date").text(e.start_date);
            $("#production_end_date").text(e.end_date);
            $("#production_total_quantity").text(e.total_quantity);
            $("#elc_production_quantity").val(e.schedule_quantity);
            //$("#elc_production_measure_unit").val(e.measure_unit);
            $("#production_days").val(e.days_between);
            $("#daily_production_qty").val(e.qty_per_day);
            if(e.child_records_count > 0 ) {
                let returnLocation = window.location.href;
                window.location.href = returnLocation.replace("new?id=" + zoneId, ""+e.id+"?zone_id="+zoneId).replace("#", "")
            }
        }
        return e.text;
    }
}

declare global {
    interface Window {
        ElcProductionNew: ElcProductionNew;
    }
}

export function LoadPage() {
    InitPage("elc productions", () => {
        InitPage("planning_calendars show", () => {
            window.ElcProductionNew = new ElcProductionNew();
        });
    });
}
